"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MAX_FILE_SIZE = void 0;
var BYTES_IN_GB = Math.pow(1024, 3),
    MAX_FILE_SIZE = 5368709120;
exports.MAX_FILE_SIZE = MAX_FILE_SIZE;